/* eslint no-underscore-dangle: ["error", { "allow": ["_meta"] }] */
import { React } from '@biletiniz/ui-core';
import { NextSeo, FAQPageJsonLd, BreadcrumbJsonLd } from '@biletiniz/seo';
import Head from 'next/head';
import { FlightsHomePage } from '@biletiniz/web-app-containers';
import { flightTicketFAQ, getCleanFaqJsonid } from '@biletiniz/web-app-utils';
import { useI18n } from '@biletiniz/intl';
import { useHotFlightBlogs } from '../src/hooks';

const FlightsHomePages = ({ hotFlightBlogs }) => {
  const i18n = useI18n();
  return (
    <>
      <NextSeo
        title=" Cheap Flights in Turkey | Turkish Airlines, Pegasus, AJet | Biletiniz"
        description=" Compare domestic and international flights from Turkey. Search Turkish Airlines, Pegasus, AJet and SunExpress fares side by side and book with confidence."
        canonical={`https://biletiniz.com/en/flight-ticket`}
      />
      <Head>
        <meta
          name="keywords"
          content="flights turkey, cheap flights turkey, domestic flights turkey, turkish airlines tickets, pegasus flights, istanbul flights"
        />
      </Head>
      <FAQPageJsonLd
        mainEntity={flightTicketFAQ[`${i18n.activeLocale}`]?.map(item => ({
          questionName: getCleanFaqJsonid(item?.question),
          acceptedAnswerText: getCleanFaqJsonid(item?.answer),
        }))}
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: i18n.t(`goToHome`),
            item: 'https://biletiniz.com/',
          },
          {
            position: 2,
            name: i18n.t(`flightTicket`),
            item: 'https://biletiniz.com/en/flight-ticket',
          },
        ]}
      />
      <FlightsHomePage hotFlightBlogs={hotFlightBlogs} />
    </>
  );
};

export async function getStaticProps(context) {
  const { default: lngDict = {} } = await import(
    `@biletiniz/intl/locales/${context.locale}.json`
  );
  const data = await useHotFlightBlogs();
  return {
    props: {
      lng: context.locale,
      lngDict,
      hotFlightBlogs: data.hotFlightBlogs,
    },
  };
}

export default FlightsHomePages;
